import { getCfTurnstileChallenge } from '@shared/lib/cf-turnstile';
import { env } from '@shared/config';

export const withCfTurnstile = () => {
  if (env.IS_SSR) {
    return;
  }
  getCfTurnstileChallenge()?.initChallengeWidget();
};
